import React, { Component } from 'react'

export class Design extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                width={20}
                height={20}
                viewBox="0 0 32 32"

            >
                <path
                    d="M20 20.854a3 3 0 0 1 1.658-2.683L24 17 17 3h-2L8 17l2.342 1.171A3 3 0 0 1 12 20.854V21h-2v8h12v-8h-2v-.146zm-8.764-4.472-.553-.276L15 7.472V15h2V7.472l4.317 8.633-.553.276A4.975 4.975 0 0 0 18 20.854V21h-4v-.146a4.972 4.972 0 0 0-2.764-4.472zM20 27h-8v-4h8v4z"
                    style={{
                        fill: "#fff",
                    }}
                />
            </svg>
        )
    }
}

export default Design